export class DateEx extends Date {
    public getTimeSec() {
        return Math.ceil(this.getTime()/1000);
    }
}
